<template><slot></slot></template>

<script setup lang="ts">
import { onMounted, getCurrentInstance } from "vue";
import { Service } from "@/apps/credit-line/services/network.service";
import { AndroidInterface } from "@/apps/credit-line/services/android.service";
import { ErrorHandler } from "@/apps/credit-line/helpers/errorHandlerWithLogger.helper";
import { useRouter } from "vue-router";
import { RoutingService } from "@/shared-services/routing.service";
import { ConsumerSettingsService } from "@/shared-services/consumer/settings.service";
import { AuthenticationHelper } from "@/apps/credit-line/helpers/authentication.helper";
import DatadogLogger from "@/shared-helpers/datadog-logger.helper";
import { SettingsCategory } from "@/shared-models/consumer/SettingsCategory";
import { recorder, RECORDING_APPS } from "@/shared-services/recording.service";
import { getRandomNumberBetweenRange } from "@/apps/credit-line/helpers/misc.helper";

declare const Android: AndroidInterface;

const ApiService = new Service();
const deviceTag = Android.getDeviceTag();
const router = useRouter();
const routingService = new RoutingService();

const settingsService = new ConsumerSettingsService(
  ApiService,
  AuthenticationHelper,
  DatadogLogger,
  SettingsCategory.CL_REGISTRATION
);

onMounted(async () => {
  try {
    const res = await ApiService.getApplicationStatus({ deviceTag });
    const creditPullForPriorBorrowers = await settingsService.getSetting(
      "creditPullForPriorBorrowers"
    );
    if (!res.data.isFunnelOpen) {
      routingService.navigate("/core-app-onboarding/coming-soon");
      return;
    }
    switch (res.data.customerType) {
      case "joint_loan_line":
        router.replace({ name: "PacmanOnboardingView" });
        break;
      case "pjm_prior_borrower":
      case "internal_user":
        // Initialize Hotjar for PJM prior borrowers
        const app = getCurrentInstance()?.appContext.app;
        recorder(app)?.startRecording(RECORDING_APPS.CREDIT_LINE);
        recorder(app)?.updateRecordingInfo(getRandomNumberBetweenRange(1000000, 1), {
          deviceTag: deviceTag,
          customerType: res.data.customerType,
        });

        if (creditPullForPriorBorrowers.enabled) {
          router.replace({
            name: "CheckCreditPullView",
          });
        } else {
          router.replace({
            name: "CreditLineRegistrationView",
          });
        }
        break;
      case "simultaneous_loan_line":
        Android.creditOfferAccepted();
        break;
      default:
        routingService.navigate("/core-app-onboarding/coming-soon");
        return;
    }
  } catch (error) {
    ErrorHandler.handleNetworkErrorAndLog(error as any);
  }
});
</script>

<style lang="scss" scoped></style>
